export default __webpack_public_path__ + "static/media/Battlestance Boots.2aa831f0.jpg";